module.exports = __webpack_public_path__ + "media/images/AM-ed4ca21095c7769317f54bca1df6255a.png";